import React from 'react'
import LtsInputText from '../../components/lottus/lts-input-text'
import LtsInputNumber from '../../components/lottus/lts-input-number'
import LtsCurrency from '../../components/lottus/lts-currency'
import LtsCalendar from '../../components/lottus/lts-calendar'
import { Checkbox } from 'primereact/checkbox'
import { resolveLookupComponent } from './lookup-registry'

/**
 * campo.tipo (da definição JSON) -> componente de edição do formulário.
 *
 * Contrato: recebe { campo, value, onChange, disabled, lookupValue, history }.
 * - onChange sempre recebe o valor puro (para lookup, o objeto { oid, descricao }).
 */
export const fieldRegistry = {
  string: ({ campo, value, onChange, disabled }) => (
    <LtsInputText
      name={campo.nome}
      label={campo.label}
      value={value || ''}
      maxLength={campo.tamanho}
      disabled={disabled}
      onChange={onChange}
    />
  ),
  int: ({ campo, value, onChange, disabled }) => (
    <LtsInputNumber
      name={campo.nome}
      label={campo.label}
      value={value}
      min={campo.min}
      max={campo.max}
      disabled={disabled}
      onChange={onChange}
    />
  ),
  numeric: ({ campo, value, onChange, disabled }) => (
    <LtsCurrency
      name={campo.nome}
      label={campo.label}
      value={value}
      mode={'decimal'}
      maxFracionDigits={campo.escala || 2}
      disabled={disabled}
      onChange={onChange}
    />
  ),
  // checkbox à esquerda do label (padrão ContratoForm); dropdown fica reservado
  // para o futuro tipo de lista de valores (enum)
  boolean: ({ campo, value, onChange, disabled }) => (
    <div>
      <Checkbox
        inputId={`chk_${campo.nome}`}
        name={campo.nome}
        checked={!!value}
        disabled={disabled}
        onChange={(e) => onChange(e.checked)}
        style={{ marginRight: '5px' }}
      />
      <label htmlFor={`chk_${campo.nome}`}>{campo.label}</label>
    </div>
  ),
  date: ({ campo, value, onChange, disabled }) => (
    <LtsCalendar name={campo.nome} label={campo.label} value={value} disabled={disabled} onChange={onChange} />
  ),
  datetime: ({ campo, value, onChange, disabled }) => (
    <LtsCalendar
      name={campo.nome}
      label={campo.label}
      value={value}
      showTime={true}
      disabled={disabled}
      onChange={onChange}
    />
  ),
  lookup: ({ campo, lookupValue, onChange, disabled, history }) => {
    const LookupComponent = resolveLookupComponent(campo.lookup && campo.lookup.chave)
    if (!LookupComponent) {
      return <span>Lookup não registrado: {campo.lookup && campo.lookup.chave}</span>
    }
    return (
      <LookupComponent
        name={campo.nome}
        label={campo.label}
        value={lookupValue}
        history={history}
        editDisabled={disabled}
        onChange={onChange}
        campoExibicao={campo.lookup && campo.lookup.campoExibicao}
        camposExibicao={campo.lookup && campo.lookup.camposExibicao}
        separador={campo.lookup && campo.lookup.separador}
      />
    )
  },
}

export function renderField(tipo, props) {
  const render = fieldRegistry[tipo]
  return render ? render(props) : null
}
